import { Button } from "@/components/ui/button";
import { PlayCircle, Trophy } from "lucide-react";

export default function BootcampHero({ content, progress, onContinue }) {
  const allDone = progress.next_day == null;
  return (
    <section data-testid="bootcamp-hero"
             className="relative overflow-hidden rounded-2xl bg-[#0A1F44] text-white shadow-sm ring-1 ring-[#C9A961]/30">
      <div className="absolute -right-24 -bottom-24 w-72 h-72 rounded-full border border-[#C9A961]/15" aria-hidden />
      <div className="relative p-5 sm:p-7 grid gap-5 sm:grid-cols-[1fr_auto] sm:items-end">
        <div className="min-w-0">
          <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.24em] text-[#C9A961] font-semibold">
            {content.subtitle}
          </div>
          <h1 className="font-serif text-3xl sm:text-4xl leading-tight mt-1">Your First 45 Days</h1>
          <p className="text-white/70 text-sm mt-2 max-w-xl">{content.description}</p>
          <div className="mt-4 max-w-md">
            <div className="flex items-baseline justify-between text-sm">
              <span data-testid="bootcamp-progress-count"><span className="font-serif text-2xl text-[#C9A961] tabular-nums">{progress.completed}</span> / {progress.total} days complete</span>
              <span className="tabular-nums text-white/80" data-testid="bootcamp-progress-pct">{progress.pct}%</span>
            </div>
            <div className="h-2 mt-2 rounded-full bg-white/15 overflow-hidden">
              <div className="h-full bg-[#C9A961] transition-[width] duration-700" style={{ width: `${progress.pct}%` }} />
            </div>
          </div>
        </div>
        <Button onClick={onContinue} data-testid="bootcamp-continue-btn"
                className="rounded-full bg-[#C9A961] text-[#0A1F44] hover:bg-[#d8bc7a] h-11 px-6 font-semibold">
          {allDone ? <Trophy className="w-4 h-4 mr-2" /> : <PlayCircle className="w-4 h-4 mr-2" />}
          {allDone ? "Bootcamp complete — review" : `Continue Training · Day ${progress.next_day}`}
        </Button>
      </div>
    </section>
  );
}
